export enum NaRenewablesPrimaryLens {
  FORECAST = 'Forecast',
  FORECAST_DIFFERENCE = 'ForecastDifference',
}
